// Text width of a row is estimated rather than measured, so the dropdown renders the same "+N" on
// every open with no layout read. Advance widths of the Source Sans Pro regular face the options use
// (app/assets/fonts/SourceSansPro), in thousandths of an em, grouped to the nearest 25.
const GLYPH_WIDTH_GROUPS = [
  [200, ' '],
  [250, '.,:;\'|ijlI'],
  [300, '!()[]{}-f'],
  [350, '/\\rt'],
  [425, '"*?sz'],
  [450, 'cx'],
  [475, 'JLvyY'],
  [500, '0123456789#$+<=>^_~aegkFVX'],
  [550, 'AbdEhnopqSTuZ'],
  [575, 'BCKPR'],
  [625, '&DG'],
  [650, 'HNOQU'],
  [725, 'Mw'],
  [825, '%@mW'],
]
const DEFAULT_GLYPH_WIDTH = 550

const GLYPH_WIDTHS = new Map(GLYPH_WIDTH_GROUPS.flatMap(([width, glyphs]) => [...glyphs].map(glyph => [glyph, width])))

// 14px with -0.02em tracking (.filter-wrapper__content .cgt-checkbox__label).
const FONT_SIZE = 14
const LETTER_SPACING_EM = -0.02

// The 328px panel minus its 16px padding on both sides, the row's 8px insets and 20px label offset,
// and 16px for a classic (Windows) scrollbar, so a row that fits never wraps on any platform.
export const ROW_TEXT_WIDTH = 244

export const estimateTextWidth = text => [...text].reduce(
  (width, glyph) => width + ((GLYPH_WIDTHS.get(glyph) ?? DEFAULT_GLYPH_WIDTH) / 1000 + LETTER_SPACING_EM) * FONT_SIZE,
  0,
)

// How many leading extensions fit on the row's one line: all of them as "Name (.a, .b, .c)", or as
// many as leave room for the count, "Name (.a, .b +1)". At least one always shows.
const countVisibleExtensions = (name, extensions, maxWidth = ROW_TEXT_WIDTH) => {
  const fits = text => estimateTextWidth(text) <= maxWidth

  if (fits(`${name} (${extensions.join(', ')})`)) return extensions.length

  for (let count = extensions.length - 1; count > 1; count -= 1) {
    if (fits(`${name} (${extensions.slice(0, count).join(', ')} +${extensions.length - count})`)) return count
  }

  return 1
}

export default countVisibleExtensions
